// extracted by mini-css-extract-plugin
module.exports = {"page-content":"Notifications_page-content__0kasq","no-notifications":"Notifications_no-notifications__5S5R7"};